export const ACCESS_TOKEN_KEY = "accessToken";
export const REFRESH_TOKEN_KEY = "refreshToken";

export const CreateTemplateCategoryDetails = [
  {
    value: 1,
    label: "Marriage Certificate",
  },
  {
    value: 2,
    label: "Power of Attorney",
  },
  {
    value: 3,
    label: "Residential Rent Agreement",
  },
  {
    value: 4,
    label: "Non disclosure aggreement",
  },
  {
    value: 5,
    label: "Others",
  },
];

export const signRoles = {
  OWNER: "owner",
  SIGNER: "signer",
  VIEWER: "viewer",
};

export const USER_TYPES = {
  ADVOCATE: "advocate",
  USER: "client",
  ADMIN: "admin",
};

export const mimeTypes = {
  PDF: "application/pdf",
  DOCX: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  DOC: "application/msword",
  HTML: "text/html",
};

export const PARTNER_CATEGORIES = {
  BLOCKCHAIN: "blockchain",
  DEFI: "defi",
  INFRASTRUCTURE: "infrastructure",
  LEGAL: "legal",
  ADVISORY: "advisory",
  MEDIA_EVENT: "mediaEvent",
  EDUCATION: "education",
  RWA: "rwa",
};

export const THEMES = {
  LIGHT: "light",
  DARK: "dark",
};

export const GITHUB_DEMO_INTEGRATION_URL = "https://github.com/LawBlocksAI/lawblocks-api-integration-demo";